import React, { Suspense, lazy, useContext } from "react";

import { Loader2 } from "lucide-react";
import { Navigate } from "react-router-dom";

import { isHtmlDesignsBuildEnabled } from "../../hooks/useHtmlDesignsEnabled";
import AuthContext from "../../store/auth-context";

const HtmlCertificateOnboarding = lazy(
  () => import("./HtmlCertificateOnboarding"),
);

export const HTML_ONBOARDING_ROLES = ["super_admin", "tenant_admin"];

function PageSkeleton() {
  return (
    <div className="pt-20 min-h-screen flex items-center justify-center bg-cfSecondary">
      <Loader2 className="h-6 w-6 animate-spin text-cfPrimary" aria-hidden />
    </div>
  );
}

export default function HtmlCertificateOnboardingRoute() {
  const authContext = useContext(AuthContext);
  const role = (
    authContext.userType ||
    localStorage.getItem("userType") ||
    ""
  ).toLowerCase();
  if (!isHtmlDesignsBuildEnabled() || !HTML_ONBOARDING_ROLES.includes(role)) {
    return <Navigate to="/issuer/tenant/certificate-onboarding" replace />;
  }
  return (
    <Suspense fallback={<PageSkeleton />}>
      <HtmlCertificateOnboarding />
    </Suspense>
  );
}
